@if (showIcon()) {
    <st-story-icon
        hasBorder
        [data]="record()"
        [type]="selectedType()"
        [attr.medium]="mediumIcon()"
        [attr.disabled]="disabled()"
        [matTooltip]="selectedTypeLabel()"
        [matMenuTriggerFor]="disabled() ? null : storyOutputTypesMenu"
        (menuOpened)="onStoryTypeMenuOpened()"
        (menuClosed)="onStoryTypeMenuClosed()" />
}
@if (showLabel()) {
    <mat-chip
        st-story-icon
        addIcon="false"
        class="st-story-output-type__title"
        [data]="record()"
        [title]="selectedTypeLabel()"
        [itemType]="selectedType()"
        [matTooltip]="selectedTypeLabel()"
        [matMenuTriggerFor]="disabled() || showIcon() ? null : storyOutputTypesMenu"
        [hasValue]="hasValue()"
        [attr.disabled]="disabled()"
        (menuOpened)="onStoryTypeMenuOpened()"
        (menuClosed)="onStoryTypeMenuClosed()">
        {{ selectedTypeLabel() }}
    </mat-chip>
}
<mat-menu
    #storyOutputTypesMenu="matMenu"
    [class]="menuClass()">
    <ng-template matMenuContent>
        @if (!disabled()) {
            <mat-selection-list
                multiple="false"
                [compareWith]="compareFunc"
                (selectionChange)="internalValueChanged($event)">
                @for (item of storyOutputTypes(); track item.id) {
                    <mat-list-option [value]="item">
                        <st-story-icon
                            matListItemIcon
                            [type]="item.id" />
                        <div matListItemTitle>{{ item.title }}</div>
                    </mat-list-option>
                }
            </mat-selection-list>
        }
    </ng-template>
</mat-menu>
